// Representative point per COUNTRIES code, used for the country-only UULE v2
// (src/lib/serpUrl.js). [lat, lng] of the capital: the GeoNames PPLC feature of
// each country (cities500 dump, CC BY 4.0, downloaded 2026-10-06). Codes with no
// PPLC use a named GeoNames feature inside the territory: AQ McMurdo Station,
// BV Bouvetøya, HM Heard Island, TK Nukunonu, UM Wake Island, IO Diego Garcia,
// IL Jerusalem, PS Ramallah, AN Willemstad, EH Laayoune.
// Only this compact table lives in the repo, never the raw dump (DEC-006).
export const COUNTRY_COORDS = {
  AF: [34.5281, 69.1723], // Kabul
  AL: [41.3274, 19.8187], // Tirana
  DZ: [36.7323, 3.0875], // Algiers
  AS: [-14.2781, -170.7025], // Pago Pago
  AD: [42.5078, 1.5211], // Andorra la Vella
  AO: [-8.8368, 13.2343], // Luanda
  AI: [18.217, -63.0578], // The Valley
  AQ: [-77.8463, 166.6682], // McMurdo Station
  AG: [17.121, -61.8433], // Saint John’s
  AR: [-34.6131, -58.3772], // Buenos Aires
  AM: [40.1776, 44.5126], // Yerevan
  AW: [12.524, -70.027], // Oranjestad
  AU: [-35.2835, 149.1281], // Canberra
  AT: [48.2085, 16.3721], // Vienna
  AZ: [40.3777, 49.892], // Baku
  BS: [25.0582, -77.3431], // Nassau
  BH: [26.2279, 50.5857], // Manama
  BD: [23.7104, 90.4074], // Dhaka
  BB: [13.1073, -59.6202], // Bridgetown
  BY: [53.9002, 27.5665], // Minsk
  BE: [50.8505, 4.3488], // Brussels
  BZ: [17.2538, -88.764], // Belmopan
  BJ: [6.4965, 2.6036], // Porto-Novo
  BM: [32.2949, -64.783], // Hamilton
  BT: [27.4661, 89.6419], // Thimphu
  BO: [-19.0333, -65.2627], // Sucre
  BA: [43.8486, 18.3564], // Sarajevo
  BW: [-24.6545, 25.9086], // Gaborone
  BV: [-54.4222, 3.3583], // Bouvetøya
  BR: [-15.7797, -47.9297], // Brasília
  IO: [-7.3126, 72.4516], // Diego Garcia
  BN: [4.8903, 114.9401], // Bandar Seri Begawan
  BG: [42.6975, 23.3241], // Sofia
  BF: [12.3657, -1.5339], // Ouagadougou
  BI: [-3.4271, 29.9246], // Gitega
  KH: [11.5625, 104.916], // Phnom Penh
  CM: [3.8667, 11.5167], // Yaoundé
  CA: [45.4112, -75.6981], // Ottawa
  CV: [14.9315, -23.5125], // Praia
  KY: [19.2866, -81.3744], // George Town
  CF: [4.3612, 18.555], // Bangui
  TD: [12.1067, 15.0444], // N'Djamena
  CL: [-33.4569, -70.6483], // Santiago
  CN: [39.9075, 116.3972], // Beijing
  CX: [-10.4217, 105.6791], // Flying Fish Cove
  CC: [-12.1568, 96.8225], // West Island
  CO: [4.6097, -74.0817], // Bogotá
  KM: [-11.7022, 43.2551], // Moroni
  CG: [-4.2661, 15.2832], // Brazzaville
  CD: [-4.3276, 15.3136], // Kinshasa
  CK: [-21.2075, -159.7755], // Avarua
  CR: [9.9339, -84.0849], // San José
  CI: [6.8205, -5.2767], // Yamoussoukro
  HR: [45.8144, 15.978], // Zagreb
  CU: [23.133, -82.383], // Havana
  CY: [35.1728, 33.354], // Nicosia
  CZ: [50.088, 14.4208], // Prague
  DK: [55.6759, 12.5655], // Copenhagen
  DJ: [11.589, 43.145], // Djibouti
  DM: [15.3017, -61.3881], // Roseau
  DO: [18.4719, -69.8923], // Santo Domingo
  EC: [-0.2298, -78.525], // Quito
  EG: [30.0626, 31.2497], // Cairo
  SV: [13.6893, -89.1872], // San Salvador
  GQ: [1.5925, 10.8236], // Ciudad de la Paz
  ER: [15.3381, 38.9318], // Asmara
  EE: [59.437, 24.7535], // Tallinn
  ET: [9.025, 38.7469], // Addis Ababa
  FK: [-51.6938, -57.857], // Stanley
  FO: [62.0097, -6.7716], // Tórshavn
  FJ: [-18.1368, 178.4253], // Suva
  FI: [60.1695, 24.9354], // Helsinki
  FR: [48.8534, 2.3488], // Paris
  GF: [4.9381, -52.3346], // Cayenne
  PF: [-17.5347, -149.5684], // Papeete
  TF: [-49.3492, 70.2194], // Port-aux-Français
  GA: [0.3924, 9.4536], // Libreville
  GM: [13.4527, -16.578], // Banjul
  GE: [41.6914, 44.8341], // Tbilisi
  DE: [52.5244, 13.4105], // Berlin
  GH: [5.556, -0.1969], // Accra
  GI: [36.1447, -5.3526], // Gibraltar
  GR: [37.9838, 23.7278], // Athens
  GL: [64.1835, -51.7216], // Nuuk
  GD: [12.0529, -61.7523], // Saint George's
  GP: [15.9971, -61.7321], // Basse-Terre
  GU: [13.4757, 144.7489], // Hagåtña
  GT: [14.6407, -90.5133], // Guatemala City
  GN: [9.538, -13.6773], // Conakry
  GW: [11.8636, -15.5977], // Bissau
  GY: [6.8045, -58.1553], // Georgetown
  HT: [18.5435, -72.3388], // Port-au-Prince
  HM: [-53.1, 73.5], // Heard Island
  VA: [41.9027, 12.4541], // Vatican City
  HN: [14.0818, -87.2068], // Tegucigalpa
  HK: [22.2783, 114.1747], // Hong Kong
  HU: [47.4984, 19.0404], // Budapest
  IS: [64.1355, -21.8954], // Reykjavík
  IN: [28.6214, 77.2148], // New Delhi
  ID: [-6.2146, 106.8451], // Jakarta
  IR: [35.6944, 51.4215], // Tehran
  IQ: [33.3406, 44.4009], // Baghdad
  IE: [53.3331, -6.2489], // Dublin
  IL: [31.769, 35.2163], // Jerusalem
  IT: [41.8919, 12.5113], // Rome
  JM: [17.997, -76.7936], // Kingston
  JP: [35.6895, 139.6917], // Tokyo
  JO: [31.9552, 35.945], // Amman
  KZ: [51.1801, 71.446], // Astana
  KE: [-1.2833, 36.8167], // Nairobi
  KI: [1.3278, 172.977], // Tarawa
  KP: [39.0339, 125.7543], // Pyongyang
  KR: [37.566, 126.9784], // Seoul
  KW: [29.367, 47.9743], // Kuwait City
  KG: [42.87, 74.59], // Bishkek
  LA: [17.9667, 102.6], // Vientiane
  LV: [56.946, 24.1059], // Riga
  LB: [33.8933, 35.5016], // Beirut
  LS: [-29.3167, 27.4833], // Maseru
  LR: [6.3005, -10.7969], // Monrovia
  LY: [32.8874, 13.1873], // Tripoli
  LI: [47.1415, 9.5215], // Vaduz
  LT: [54.6892, 25.2798], // Vilnius
  LU: [49.6098, 6.1327], // Luxembourg
  MO: [22.2006, 113.5461], // Macau
  MK: [41.9965, 21.4314], // Skopje
  MG: [-18.9137, 47.5361], // Antananarivo
  MW: [-13.9669, 33.7873], // Lilongwe
  MY: [3.1412, 101.6865], // Kuala Lumpur
  MV: [4.1752, 73.5092], // Male
  ML: [12.6091, -7.9752], // Bamako
  MT: [35.8997, 14.5148], // Valletta
  MH: [7.0897, 171.3803], // Majuro
  MQ: [14.6037, -61.0742], // Fort-de-France
  MR: [18.0858, -15.9785], // Nouakchott
  MU: [-20.1619, 57.4989], // Port Louis
  YT: [-12.7823, 45.2288], // Mamoudzou
  MX: [19.4285, -99.1277], // Mexico City
  FM: [6.9248, 158.1611], // Palikir
  MD: [47.009, 28.8594], // Chisinau
  MC: [43.7372, 7.4215], // Monaco
  MN: [47.9077, 106.8832], // Ulan Bator
  MS: [16.7055, -62.2129], // Plymouth
  MA: [34.0132, -6.8326], // Rabat
  MZ: [-25.9655, 32.5832], // Maputo
  MM: [19.745, 96.1297], // Nay Pyi Taw
  NA: [-22.5594, 17.0832], // Windhoek
  NR: [-0.5508, 166.9252], // Yaren
  NP: [27.7017, 85.3206], // Kathmandu
  NL: [52.374, 4.8897], // Amsterdam
  AN: [12.1225, -68.8864], // Willemstad
  NC: [-22.2741, 166.4488], // Nouméa
  NZ: [-41.2866, 174.7756], // Wellington
  NI: [12.1328, -86.2504], // Managua
  NE: [13.5137, 2.1098], // Niamey
  NG: [9.0579, 7.4951], // Abuja
  NU: [-19.0529, -169.9196], // Alofi
  NF: [-29.0546, 167.9663], // Kingston
  MP: [15.2123, 145.7545], // Saipan
  NO: [59.9127, 10.7461], // Oslo
  OM: [23.5841, 58.4078], // Muscat
  PK: [33.7215, 73.0433], // Islamabad
  PW: [7.5008, 134.6238], // Ngerulmud
  PS: [31.8996, 35.2042], // Ramallah
  PA: [8.9936, -79.5197], // Panama City
  PG: [-9.4772, 147.1509], // Port Moresby
  PY: [-25.2865, -57.647], // Asunción
  PE: [-12.0432, -77.0282], // Lima
  PH: [14.6042, 120.9822], // Manila
  PN: [-25.066, -130.1015], // Adamstown
  PL: [52.2298, 21.0118], // Warsaw
  PT: [38.7251, -9.1498], // Lisbon
  PR: [18.4663, -66.1057], // San Juan
  QA: [25.2855, 51.531], // Doha
  RE: [-20.8823, 55.4504], // Saint-Denis
  RO: [44.4323, 26.1063], // Bucharest
  RU: [55.752, 37.6178], // Moscow
  RW: [-1.95, 30.0588], // Kigali
  SH: [-15.9249, -5.7182], // Jamestown
  KN: [17.2955, -62.725], // Basseterre
  LC: [13.9957, -61.0061], // Castries
  PM: [46.7791, -56.1773], // Saint-Pierre
  VC: [13.1553, -61.2274], // Kingstown
  WS: [-13.8333, -171.7667], // Apia
  SM: [43.9367, 12.4464], // San Marino
  ST: [0.3376, 6.7299], // São Tomé
  SA: [24.6877, 46.7219], // Riyadh
  SN: [14.6937, -17.4441], // Dakar
  RS: [44.804, 20.4651], // Belgrade
  SC: [-4.62, 55.455], // Victoria
  SL: [8.4871, -13.2356], // Freetown
  SG: [1.2897, 103.8501], // Singapore
  SK: [48.1482, 17.1067], // Bratislava
  SI: [46.0511, 14.5051], // Ljubljana
  SB: [-9.4333, 159.95], // Honiara
  SO: [2.0371, 45.3438], // Mogadishu
  ZA: [-25.7449, 28.1878], // Pretoria
  GS: [-54.2811, -36.5092], // Grytviken
  ES: [40.4165, -3.7026], // Madrid
  LK: [6.9355, 79.8487], // Colombo
  SD: [15.5518, 32.5324], // Khartoum
  SR: [5.8664, -55.1668], // Paramaribo
  SJ: [78.2233, 15.6469], // Longyearbyen
  SZ: [-26.3167, 31.1333], // Mbabane
  SE: [59.3294, 18.0687], // Stockholm
  CH: [46.9481, 7.4474], // Bern
  SY: [33.5102, 36.2913], // Damascus
  TW: [25.0531, 121.5264], // Taipei
  TJ: [38.5358, 68.779], // Dushanbe
  TZ: [-6.1722, 35.7395], // Dodoma
  TH: [13.754, 100.5014], // Bangkok
  TL: [-8.5586, 125.5736], // Dili
  TG: [6.1287, 1.2215], // Lomé
  TK: [-9.2005, -171.848], // Nukunonu
  TO: [-21.1368, -175.2011], // Nuku‘alofa
  TT: [10.6667, -61.5189], // Port of Spain
  TN: [36.819, 10.1658], // Tunis
  TR: [39.9199, 32.8543], // Ankara
  TM: [37.95, 58.3833], // Ashgabat
  TC: [21.4612, -71.1419], // Cockburn Town
  TV: [-8.5243, 179.1942], // Funafuti
  UG: [0.3163, 32.5822], // Kampala
  UA: [50.4547, 30.5238], // Kyiv
  AE: [24.4512, 54.397], // Abu Dhabi
  GB: [51.5085, -0.1257], // London
  US: [38.8951, -77.0364], // Washington
  UM: [19.28, 166.6462], // Wake Island
  UY: [-34.9033, -56.1882], // Montevideo
  UZ: [41.2647, 69.2163], // Tashkent
  VU: [-17.7365, 168.3137], // Port-Vila
  VE: [10.488, -66.8792], // Caracas
  VN: [21.0245, 105.8412], // Hanoi
  VG: [18.4269, -64.6208], // Road Town
  VI: [18.3419, -64.9307], // Charlotte Amalie
  WF: [-13.2816, -176.1745], // Mata-Utu
  EH: [27.1418, -13.188], // Laayoune
  YE: [15.3545, 44.2065], // Sanaa
  ZM: [-15.4067, 28.2871], // Lusaka
  ZW: [-17.8277, 31.0534], // Harare
};
